import type { LookbookItemDataFragment } from "../graphql/types";

export function useItemDetails(item: LookbookItemDataFragment) {
  const vendor =
    item.resource && "vendor" in item.resource && item.resource.vendor?.length
      ? item.resource.vendor
      : null;
  const price = item.resource?.price ?? null;
  const title = item.resource?.title?.length ? item.resource.title : null;
  const comments = item.comments?.length ? item.comments : null;

  const showVendor = typeof vendor === "string";
  const showPrice = price !== null;
  const showTitle = title !== null;
  const showComments = comments !== null;

  return {
    showVendor,
    vendor,
    showPrice,
    price,
    showTitle,
    title,
    showComments,
    comments,
  };
}
